import React from 'react';
import './FaqAccordion.css';
import Accordion from 'react-bootstrap/Accordion';

function FaqAccordion() {
  return (
    <div className='faq-section'>
        <div className='container d-flex flex-column align-items-center'>
            <h2 className='text-center text-capitalize mb-5'>Frequently asked questions</h2>
            <p className='text-center mb-5'>Here we look at the some of most frequently asked question by you regarding our organization and courses</p>
            <Accordion defaultActiveKey="" flush>
                <Accordion.Item eventKey='0'>
                    <Accordion.Header>Where is it situated?</Accordion.Header>
                    <Accordion.Body>
                        Ans: Location: New Baneshwor (Chakku Bakku Marg), Kathmandu Exactly it lies on way to Eyeplex Mall.
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey='1'>
                    <Accordion.Header>What courses are offered?</Accordion.Header>
                    <Accordion.Body>
                       We offer wide range of courses like language classes of languages like Korean, Japanese, English, Examination courses like IELTS, PTE and Many More.
                    </Accordion.Body>
                </Accordion.Item>
                
            </Accordion>
        </div>
    </div>
  )
}

export default FaqAccordion;